module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-marquee",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('ul', {
    ref: "box",
    staticClass: "vux-marquee-box",
    style: ({
      transform: ("translate3d(0," + _vm.currenTranslateY + "px,0)"),
      transition: ("transform " + (_vm.noAnimate ? 0 : _vm.duration) + "ms")
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79691a2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/marquee/marquee.vue
// module id = 419
// module chunks = 1